import React, { useState, useEffect } from 'react';
import { FiDownload } from 'react-icons/fi'; // npm install react-icons
import '../../styles//crud.css';
import '../../styles//botones_dflt.css';
import Spinner from "../spinner";
import * as apiSiniestros from '../../services/apiSiniestros.js';
import * as apiTiposDocumentos from '../../services/apiTiposDocumentos.js';
import { convertFileToBase64, descargarDocumentoSiniestro,convertirFechaParaInputDate } from '../../functions/fileFunctions.js';
import * as alerts from '../../functions/alerts.js';


const Siniestros = ({ polizaId }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]); // Estado para almacenar filas
  const [documentos, setDocumentos] = useState([]); // Estado para almacenar filas
  const [formData, setFormData] = useState({ monto: '',deducible: '',rasa: '', indemnizacion: '', observaciones: '', fecha: ''}); // Estado del formulario
  const [isFormModalOpen, setIsFormModalOpen] = useState(false); // Control del modal de ingreso/edición
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); // Control del modal de eliminación
  const [deleteIndex, setDeleteIndex] = useState(null); // Índice de la fila a eliminar
  const [isEditing, setIsEditing] = useState(false); // Estado para editar
  const [editIndex, setEditIndex] = useState(null); // Índice de la fila a editar
  const [tipoDocOptions, setTipoDocOptions] = useState([]);

  // Cargar datos desde la API al montar el componente
    const fetchData = async (polizaID) => {
        try{
          const json = await apiSiniestros.cargarSiniestros(polizaID);
          const formattedData = json.siniestros.map((item) => ({
            id: item.id,
            monto: item.monto,
            deducible: item.deducible,
            rasa: item.rasa,
            indemnizacion: item.indemnizacion,
            observaciones: item.observaciones,
            fecha: item.fecha
          }));
          setData(formattedData);
          setLoading(false);
        } catch (error) {
          console.error('Error al cargar los datos:', error);
      }
    };

  const storedUser = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
      fetchData(polizaId);
    }, [polizaId]);

  // Manejar los cambios en los campos del formulario
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Abrir el modal de formulario para agregar o editar
  const openFormModal = async (index = null) => {
    if (index !== null) {
      try {
        const jsonCli = await apiSiniestros.obtenerSiniestro(data[index].id);
        if(jsonCli){
          const formattedData = ({
            id: jsonCli.id,
            monto: jsonCli.monto,
            deducible: jsonCli.deducible,
            rasa: jsonCli.rasa,
            indemnizacion: jsonCli.indemnizacion,
            observaciones: jsonCli.observaciones,
            fecha: convertirFechaParaInputDate(jsonCli.fecha)
          });
          setFormData(formattedData);
          const jsonDoc = await apiSiniestros.listarDocumentos(data[index].id);
          setDocumentos(Array.isArray(jsonDoc) ? jsonDoc : []);
        }
      } catch (error) {
        console.error('Error al cargar los datos:', error);
      }
      //setFormData(data[index]);  Cargar datos existentes si es edición
      setIsEditing(true);
      setEditIndex(data[index].id);
    } else {
      setFormData({ monto: '',deducible: '',rasa: '', indemnizacion: '', observaciones: '', fecha: ''}); 
      setDocumentos([]);
      setIsEditing(false);
    }
    const jsonTipoDoc = await apiTiposDocumentos.cargarTiposDocumentos(3);
    if(jsonTipoDoc){
      const tipoDoc = jsonTipoDoc.tiposDocs.map((item) => ({
        id: item.id,
        tipo: item.tipo
      }));
      setTipoDocOptions(tipoDoc);
    }
    setIsFormModalOpen(true);
  };

  // Cerrar el modal de formulario
  const closeFormModal = () => {
    if (polizaId){
      fetchData(polizaId);
    }
    setIsFormModalOpen(false);
  };

  // Guardar datos (Agregar o Editar)
  async function handleFormSubmit(e) {
    e.preventDefault();
    if (isEditing) {
      try {
//gestion de siniesto
        const response = await apiSiniestros.actualizarSiniestro(formData, storedUser, editIndex);
        if (response.ok) {
//gestion de siniesto
//-----------------------------------------
//gestion de documentos
          const nuevosDocumentos = documentos.filter((elemento) => !elemento.id);
          const resultados_add_doc = await Promise.all(
            nuevosDocumentos.map((elemento) => { 
              return apiSiniestros.agregarDocumento(elemento, editIndex,storedUser);  
            })
          );
          resultados_add_doc.forEach((response) => {
            if (!response.ok) {
              console.error('Error al agregar el documento:', response.statusText);
            }
          });
          const documentosExistentes = documentos.filter((elemento) => elemento.id && elemento.bandera === "modificado");
          const resultados_upd_doc = await Promise.all(
            documentosExistentes.map((elemento) => { 
              return apiSiniestros.actualizarDocumento(elemento, storedUser);  
            })
          );
          resultados_upd_doc.forEach((response) => {
            if (!response.ok) {
              console.error('Error al editar el documento:', response.statusText);
            }
          });
//gestion de documentos
//-----------------------------------------
          alerts.handleSuccess('Éxito!','Cambios guardados correctamente')
        } else {
          console.error('Error al guardar cambios:', response.statusText);
        }
      } catch (error) {
        console.error('Error al hacer la solicitud:', error);
      }
    } else {
      const response = await apiSiniestros.crearSiniestro(formData, polizaId, storedUser);
      if (response.ok) {
        const data = await response.json();
        const nuevoCliente=data.siniestro_id;
        console.log(nuevoCliente)
        alerts.handleSuccess('Éxito!','Siniestro creado correctamente')
        setIsFormModalOpen(false);
      } else {
        console.error('Error al agregar nuevo siniestro:', response.statusText);
      }
    }
    closeFormModal();
  }

  const openDeleteModal = (index) => {
    setDeleteIndex(index);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const confirmDelete = async () => {
    const response = await apiSiniestros.eliminarSiniestro(data[deleteIndex].id,storedUser);
    if (response.ok) {
      alerts.handleSuccess('Éxito!','Siniestro eliminado correctamente')
    } else {
      console.error('Error al eliminar el siniestro:', response.statusText);
    }
    if (polizaId) {
      fetchData(polizaId);
    }
    closeDeleteModal();
  };

  const handleChangeDoc = async (event,index) => {
    const file = event.target.files[0];
    const nuevosDocumentos = [...documentos];
    if (!file) return;
    const nombre_ = file.name;
    const extension_ = file.name.split('.').pop();
    const contenido_ = await convertFileToBase64(file);
    nuevosDocumentos[index]["nombre"]=nombre_;
    nuevosDocumentos[index]["extension"]=extension_;
    nuevosDocumentos[index]["contenido"]=contenido_;
    nuevosDocumentos[index]["bandera"]="modificado";
    setDocumentos(nuevosDocumentos);
  };

  const handleChangeTipoDoc = (index, e) => {
    const updatedDocuments = [...documentos];
    updatedDocuments[index].tipo = e.target.value;
    setDocumentos(updatedDocuments);
  };
  
  const handleDeleteDoc = async (index) => {
    if (documentos[index].id){
        const response = await apiSiniestros.eliminarDocumento(documentos[index].id,storedUser)
        if (response.ok) {
          alerts.handleSuccess('Éxito!','Documento eliminado correctamente')
        } else {
          console.error('Error al eliminar el correo:', response.statusText);
        }
    }
    setDocumentos((prevDocumentos) => prevDocumentos.filter((_, i) => i !== index));        
  };

  const agregarDocumento = () => {
    setDocumentos([...documentos, {tipo: 0 , nombre: "", bandera: "nuevo", extension: "", contenido: ""}]);
  };

  return (
    <div className="crud-table">
    {!loading && <button className='button_new' onClick={() => openFormModal()}>Añadir Siniestro</button>}
      {/* Tabla */}
      {loading ? <Spinner /> :
      <table>
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Observaciones</th>
            <th>Monto</th>
            <th>Deducible</th>
            <th>Rasa</th>
            <th>Indemnización</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((item, index) => (
              <tr key={item.id}>
                <td>{item.fecha}</td>
                <td>{item.observaciones.slice(0, 30)}</td>
                <td>{item.monto}</td>
                <td>{item.deducible}</td>
                <td>{item.rasa}</td>
                <td>{item.indemnizacion}</td>
                <td>
                  <button className="editar" onClick={() => openFormModal(index)}>Editar</button>
                  <button className="eliminar" onClick={() => openDeleteModal(index)}>Eliminar</button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5">No hay datos</td>
            </tr>
          )}
        </tbody>
      </table>}

      {/* Modal de Formulario */}
      {isFormModalOpen && (
        <div className="modal">
          <div className="modal-content modal-content-wide">
            <h2>{isEditing ? 'Editar Siniestro' : 'Añadir Siniestro'}</h2>
            <table>
              <tbody>
                <tr>
                  <td className='modal-region'>
                    <h3 className='center'>Información General</h3>
                    <form onSubmit={handleFormSubmit} className='form_crud'>
                      <div className='container'>
                        <div className='header-label'>
                          <label htmlFor="fecha">Fecha</label>
                          <input
                            type="date"
                            name="fecha"
                            placeholder="Fecha"
                            value={formData.fecha}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div className='header-label'>
                          <label htmlFor="observaciones">Observaciones</label>
                          <textarea
                            name="observaciones"
                            placeholder="Observaciones"
                            value={formData.observaciones}
                            onChange={handleChange}
                            rows={6} // Puedes ajustar el número de líneas visibles
                            style={{ width: '100%' }} // O define un ancho específico si deseas
                            required
                          />
                        </div>
                      </div>
                      <div className='container'>
                        <div className='header-label'>
                          <label htmlFor="monto">Monto</label>
                          <input
                            type="number"
                            name="monto"
                            placeholder="Monto"
                            value={formData.monto}
                            onChange={handleChange}
                            
                          />
                        </div>
                        <div className='header-label'>
                          <label htmlFor="deducible">Deducible</label>
                          <input
                            type="number"
                            name="deducible"
                            placeholder="Deducible"
                            value={formData.deducible}
                            onChange={handleChange}
                            
                          />
                        </div>
                      </div>
                      <div className='container'>
                        <div className='header-label'>
                          <label htmlFor="rasa">Rasa</label>
                          <input
                            type="number"
                            name="rasa"
                            placeholder="Rasa"
                            value={formData.rasa}
                            onChange={handleChange}
                          />
                        </div>
                        <div className='header-label'>
                          <label htmlFor="indemnizacion">Indemnización</label>
                          <input
                            type="number"
                            name="indemnizacion"
                            placeholder="Indemnización"
                            value={formData.indemnizacion}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
  
                    </form>
                  </td>
                  {isEditing && (
                  <td className='modal-region'>
                    <button className='button_new' onClick={agregarDocumento}>Añadir Documento</button>
                    {/* Tabla Documentos */}
                    {documentos.length > 0 && (
                        <table >
                        <tbody>
                            {documentos.map((documentos, index) => (
                            <tr key={index}>
                                <td>
                                <select id="options"
                                    type="text"
                                    name="tipo"
                                    placeholder="Tipo Documento"
                                    value={documentos.tipo}
                                    onChange={(e) => handleChangeTipoDoc(index, e)}
                                    required
                                    disabled={documentos.id}
                                  > <option key='-1' value='-1'>
                                      -Seleccione-
                                    </option>
                                    {tipoDocOptions.map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.tipo}
                                    </option>
                                    ))}
                                  </select>
                                </td>

                                <td>
                                <input
                                  id="archivo"
                                  type="file"
                                  name="archivo"
                                  placeholder="Elija el archivo a cargar"
                                  onChange={(event) => handleChangeDoc(event, index)}
                                  required
                                />
                                </td>
                                <td>
                                {documentos.id ? (
                                      <button onClick={() => descargarDocumentoSiniestro(documentos.id)}
                                        style={{ textDecoration: 'none', color: 'black', background: 'none' }}
                                      >
                                        <FiDownload size={30}/>
                                      </button>
                                      ):(null)
                                }
                                </td>
                                <td>
                                <button onClick={() => handleDeleteDoc(index)}>X</button>
                                </td>
                            </tr>
                            ))}
                        </tbody>
                        </table>  
                    )}
                  </td> 
                  )}
                  </tr>
                </tbody>
            </table>
            <button type="submit" className='guardar' onClick={handleFormSubmit}>{isEditing ? 'Actualizar' : 'Añadir'}</button>
            <button type="button" className='cancelar' onClick={closeFormModal}>Cancelar</button>
          </div>
        </div>
      )}

      {/* Modal de Confirmación de Eliminación */}
      {isDeleteModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h2>Confirmar Eliminación</h2>
            <p>¿Estás seguro de que deseas eliminar este registro?</p>
            <button onClick={confirmDelete}>Sí, eliminar</button>
            <button onClick={closeDeleteModal}>Cancelar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Siniestros;